import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";

export class PaymentTransactionService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getPaymentContent(fundID, paymentTransactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/payment-transactions/${paymentTransactionId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    getPaymentsListData(fundID,
                        fullName,
                        groupName,
                        groupCode,
                        startDate,
                        endDate,
                        status,
                        page, size = 15) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/payment-transactions`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size,
                    "full-name": fullName,
                    "group-code": groupCode,
                    "group-name": groupName,
                    "start-pay-at": startDate.length === 10 ? moment.from(startDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
                    "end-pay-at": endDate.length === 10 ? moment.from(endDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
                    "status": status !== -1 ? status : "",
                }
            ).then(resolve).catch(reject)
        })
    }
}